import { render, staticRenderFns } from "./InvoiceLines.vue?vue&type=template&id=f96673b2&"
import script from "./InvoiceLines.vue?vue&type=script&lang=js&"
export * from "./InvoiceLines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports